import { render } from "./Alert.vue?vue&type=template&id=70474018&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import "./Alert.vue?vue&type=style&index=0&id=70474018&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70474018"

export default script